import { jsx as e, jsxs as B } from "react/jsx-runtime";
import { forwardRef as I } from "react";
import { FormControl as S } from "../FormControl/FormControl.mjs";
import { Checkbox as j, VStack as v, Box as c } from "@chakra-ui/react";
import { Badge as y } from "../../dataDisplay/Badge/Badge.mjs";
import R from "./CustomCheckboxIcon.mjs";
const T = I(
  (s, d) => {
    const {
      children: t,
      name: a,
      formHelperText: n,
      hideOptionalLabel: i = !1,
      id: l = a,
      isIndeterminate: m = !1,
      isRequired: h,
      label: x,
      size: b = "md",
      variant: o = "checkbox",
      value: p,
      error: f,
      onChange: k,
      controlStyleProps: C,
      controlClassName: g,
      "data-testid": r,
      ...N
    } = s;
    return /* @__PURE__ */ e(
      S,
      {
        error: f,
        formHelperText: n,
        isRequired: h,
        label: x,
        name: a,
        hideOptionalLabel: i,
        id: l,
        className: g,
        "data-testid": r && `${r}-control`,
        ...C,
        children: /* @__PURE__ */ e(
          j,
          {
            onChange: (u) => {
              k(u.target.checked);
            },
            isChecked: !!p,
            size: b,
            ref: d,
            variant: o,
            name: a,
            "data-testid": r,
            isIndeterminate: m,
            icon: /* @__PURE__ */ e(R, {}),
            ...o === "card" && { alignItems: "start" },
            ...N,
            children: o === "card" ? /* @__PURE__ */ B(v, { align: "stretch", spacing: 3, children: [
              /* @__PURE__ */ e(c, { className: "checkbox-card-badge-container", children: /* @__PURE__ */ e(y, { className: "checkbox-card-selected-badge", status: "recommendation", children: "Selected" }) }),
              /* @__PURE__ */ e(c, { className: "checkbox-card-child-container", children: t })
            ] }) : t
          }
        )
      }
    );
  }
);
T.displayName = "BooleanCheckbox";
export {
  T as BooleanCheckbox
};
